export const ProjectName = 'Tavo Reklama'
export const ProjectDescription = 'Elektroninė spaustuvė Jūsų namuose. Pristatymas visoje Lietuvoje per 24h. Greita, pigu, patogu. Mažų ir vidutinių tiražų spaustuvė. Nemokamai sukurk savo ar įkelkite failą ir spausdinkite!'
export const ProjectURL = 'https://reklama123.herokuapp.com'
export const ProjectLogo = ''